module.exports = __webpack_public_path__ + "img/systemSetting.3a9f9cbd.svg";